<script>
export default {
    props: {
        vat: {}
    }
};
</script>

<template>
    <div class="v-vat small">
        <span v-if="vat === 1" class="text-success">
            <i class="far fa-check"></i> {{ $t("vouchers.vat") }}
        </span>
        <span v-else-if="vat === 0" class="text-warning"
            ><i class="far fa-times"></i> {{ $t("vouchers.vat") }}
        </span>
        <span v-else-if="vat === 2" class="text-warning"
            ><i class="far fa-question"></i> {{ $t("vouchers.vat_unknown") }}
        </span>
    </div>
</template>

<style lang="scss"></style>
